/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hide_medium'
export default icon
